import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';

import { TabValue } from '../config';

type GetTabValuesParams = {
  role: OrganizationStaffRoleType | undefined;
  canEditStaff: boolean;
  isShopAvailable: boolean;
  showTemplates: boolean;
  showAnalytics: boolean;
};

export const getTabValuesByDoctorRoles = ({
  role,
  canEditStaff,
  isShopAvailable,
  showTemplates,
  showAnalytics,
}: GetTabValuesParams) => {
  const isFullAccess =
    role === OrganizationStaffRoleType.OrganizationStaffRoleType_FullAccess;
  const isClinicalAccess =
    role === OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess;

  if (!isFullAccess && !isClinicalAccess) {
    return [TabValue.CompanyInfo];
  }

  return [
    TabValue.CompanyInfo,
    ...(canEditStaff ? [TabValue.Staff] : []),
    ...(showTemplates ? [TabValue.Templates] : []),
    ...(showAnalytics ? [TabValue.Analytics] : []),
    ...(isFullAccess ? [TabValue.BillingInfo] : []),
    ...(isFullAccess && isShopAvailable ? [TabValue.SubscriptionPlans] : []),
  ];
};
